import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=18c21776&scoped=true&"
import script from "./CheckList.vue?vue&type=script&lang=js&"
export * from "./CheckList.vue?vue&type=script&lang=js&"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=18c21776&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c21776",
  null
  
)

export default component.exports